
import React, { Component } from "react";
import BiographyEntry from '../../model/biographyEntry';
import { parseMarkdown2Html } from '../../util/markdownUtil';

interface TimelineEntryProps {
    idx: number;
    bioEntry: BiographyEntry;
    arr: BiographyEntry[];
}

class TimelineEntry extends Component<TimelineEntryProps, {}> {

    render() {

        const {
            idx,
            bioEntry,
            arr,
        } = this.props;

        return (
            <div className="row d-flex justify-content-center">
                <div className={`col-12 col-md-5 col-lg-5 col-xl-5 py-2 order-1 ${idx % 2 === 0 ? '' : 'order-md-3 order-lg-3 order-xl-3'}`}>
                    {this.buildTextCard(bioEntry)}
                </div>
                <div className="col-auto text-center flex-column d-none d-sm-flex order-2">
                    <div className="row">
                        <div className={idx === 0
                            ? 'col'
                            : 'col border-right border-secondary'}>&nbsp;</div>
                        <div className="col">&nbsp;</div>
                    </div>
                    <h5 className="m-2">
                        <span className="badge badge-pill bg-light border border-secondary">&nbsp;</span>
                    </h5>
                    <div className="row h-100">
                        <div className={idx === arr.length - 1
                            ? 'col'
                            : 'col border-right border-secondary'}>&nbsp;</div>
                        <div className="col">&nbsp;</div>
                    </div>
                </div>
                <div className={`col-12 col-md-4 col-lg-4 col-xl-4 py-2 order-3 ${idx % 2 === 0 ? '' : 'order-md-1 order-lg-1 order-xl-1 '}`}>
                    {this.buildImagesCard(bioEntry)}
                </div>
            </div>
        );
    }

    buildTextCard(bioEntry: BiographyEntry) {
        return (
            <div className="sticky-top z-999">
                <div className="card mb-3 top-123">
                    <div className="card-header">
                        <div className="row">
                            <div className="col-10 d-flex align-items-center justify-content-begin">
                                <p className="h4 fw-300 mb-0">{bioEntry.startYear} - {bioEntry.endYear}</p>
                            </div>
                            {/* <div className="col-2 d-flex align-items-center justify-content-end">
                                            <p className="mb-0">{this.props.subtitle}</p>
                                        </div> */}
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col">
                                <p
                                    className="card-text align-self-start"
                                    dangerouslySetInnerHTML={{ __html: parseMarkdown2Html(bioEntry.content) }}></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildImagesCard(bioEntry: BiographyEntry) {
        return (
            <div className="col d-flex flex-column flex-wrap align-items-center pt-123">
                {bioEntry.images.map((img, idx) => {
                    return (
                        <div key={idx}>
                            <a href={`${process.env.REACT_APP_STRAPI_HOST}${img.link}`}>
                                <img
                                    className="mb-2"
                                    src={`${process.env.REACT_APP_STRAPI_HOST}${img.url}`}
                                    alt={img.title}
                                    width="100%" />
                            </a>
                            <p className="fw-300">{img.title}</p>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default TimelineEntry;